import { Injectable, isDevMode } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import type { RumErrorEvent, RumEvent, RumResourceEvent } from '@datadog/browser-rum';
import { environment } from 'src/environments/environment';

/** Patterns that indicate dev-only WebSocket / HMR noise we should not send to RUM. */
const DEV_WS_NOISE_PATTERNS = /webpack-dev-server|ng-cli-ws|WebSocket connection to.*failed/i;

@Injectable({
  providedIn: 'root',
})
export class DatadogService {
  currentEnv = environment.name;

  constructor() {}

  /**
   * Returns true if the RUM event should be dropped (dev WebSocket / HMR noise).
   */
  private static isDevWebSocketNoise(event: RumEvent): boolean {
    if (event.type === 'error') {
      const msg = (event as RumErrorEvent).error?.message ?? '';
      const stack = (event as RumErrorEvent).error?.stack ?? '';
      return DEV_WS_NOISE_PATTERNS.test(msg) || DEV_WS_NOISE_PATTERNS.test(stack);
    }
    if (event.type === 'resource') {
      const url = (event as RumResourceEvent).resource?.url ?? '';
      return DEV_WS_NOISE_PATTERNS.test(url);
    }
    return false;
  }

  initialize(): void {
    if (isDevMode() || this.currentEnv === 'development') {
      return;
    }

    datadogRum.init({
      applicationId: '1296ab3c-f9e5-4bb8-8a44-2e0fdec140eb',
      clientToken: 'pub13af3461db02780fe7e2c6d061ac6ab2',
      site: 'datadoghq.com',
      service: 'store-ui',
      env: this.currentEnv,
      version: '1.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'allow', // allowing user input to be seen as there's no sensitive data
      trackSessionAcrossSubdomains: true,
      beforeSend: (event) => !DatadogService.isDevWebSocketNoise(event),
    });

    // datadogRum.startSessionReplayRecording();

    // hiding for now to see if we want to use just RUM logging
    // datadogLogs.init({
    //   clientToken: 'pub13af3461db02780fe7e2c6d061ac6ab2',
    //   site: 'datadoghq.com',
    //   service: 'store-ui',
    //   env: this.currentEnv,
    //   forwardErrorsToLogs: true,
    //   sessionSampleRate: 100,
    //   trackSessionAcrossSubdomains: true,
    // });
  }
}
